import React from 'react';
import Checkbox from '../../checkbox';
import TicketStub from '../';
import TicketStubContent from '../content';
import TicketStubOutline from '../outline';
import TicketStubSidebar from '../side_bar';
import TicketStubInfo from '../ticket_stub_info';
import translate from '../../../../utils/translate';
const T = React.PropTypes;

export default class Upsell extends React.Component {
  static propTypes = {
    upsell: T.object,
    onClick: T.func
  };

  renderUpsellItems = () => {
    const upsells = {};
    this.props.upsell.tickets.forEach((ticket) => {
      const type = ticket.seat_name.type;
      upsells[type] = upsells[type] || {};
      upsells[type].qty = (upsells[type].qty || 0) + 1;
    });
    const returner = [];
    Object.keys(upsells).forEach((type, i) => {
      returner.push(<li key={i}>{type} x{upsells[type].qty}</li>);
    });
    return returner;
  };

  render () {
    const type = this.props.upsell.isSelected ? 'ticket_list_item_active' : 'ticket_list_item';

    return (
      <TicketStub dataComponent={this.props.upsell.seat_id}>
        <TicketStubOutline
          isBlue={!this.props.upsell.isSelected && !this.props.upsell.isCancelled}
          isGreen={this.props.upsell.isSelected}
          ovalColorClass="ticket_stub_outline__oval--my_tickets_gray" />
        <TicketStubContent dataComponent={type}>
          <TicketStubSidebar>
            { (this.props.upsell.downloadable && !this.props.upsell.isCancelled) &&
            <Checkbox checked={this.props.upsell.isSelected} onChange={this.props.onClick} />
            }
          </TicketStubSidebar>
          <TicketStubInfo>
            <div className="ticketstub__details--upsell">
              <div className="ticketstub__row">
                <div className="ticketstub__cell">
                  <div className="ticketstub__cell__label">
                    {translate('upcomingEventsModule', 'TICKET_ADDITIONAL_ITEMS')}
                  </div>
                  <div className="ticketstub__cell__text">
                    {this.props.upsell.name}
                    <ul className="ticketstub__details__upsellitems">
                      {this.renderUpsellItems()}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </TicketStubInfo>
        </TicketStubContent>
      </TicketStub>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/upsell.js